import {
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
  CartesianGrid,
} from "recharts";
import { fmtAUD } from "@/lib/finance";

const COLORS = { income: "#22c55e", expense: "#ef4444", net: "#ffffff" };

function ChartTooltip({ active, payload, label }) {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="rounded-sm border border-border bg-popover px-3 py-2 text-xs shadow-md" data-testid="chart-tooltip">
      <p className="mb-1 font-medium">{label}</p>
      {payload.map((p) => (
        <div key={p.dataKey} className="flex items-center justify-between gap-4 tabular">
          <span className="flex items-center gap-1.5">
            <span className="inline-block h-2 w-2 rounded-full" style={{ background: p.color }} />
            <span className="text-muted-foreground capitalize">{p.dataKey}</span>
          </span>
          <span style={{ color: p.color }}>{fmtAUD(p.value)}</span>
        </div>
      ))}
    </div>
  );
}

export function PnLChart({ data, mode }) {
  return (
    <div className="h-[300px] w-full" data-testid="pnl-chart">
      <ResponsiveContainer width="100%" height="100%" minWidth={0} debounce={1}>
        <ComposedChart data={data || []} margin={{ top: 10, right: 8, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="0" stroke="#1a1a1a" vertical={false} />
          <XAxis
            dataKey="label"
            tick={{ fill: "#a3a3a3", fontSize: 11, fontFamily: "IBM Plex Mono" }}
            tickLine={false}
            axisLine={{ stroke: "#262626" }}
          />
          <YAxis
            tick={{ fill: "#a3a3a3", fontSize: 11, fontFamily: "IBM Plex Mono" }}
            tickLine={false}
            axisLine={false}
            width={64}
            tickFormatter={(v) => `$${Math.round(v / 1000) ? `${Math.round(v / 100) / 10}k` : v}`}
          />
          <Tooltip content={<ChartTooltip />} cursor={{ fill: "rgba(255,255,255,0.04)" }} />
          <Legend
            wrapperStyle={{ fontSize: 11, fontFamily: "IBM Plex Mono", color: "#a3a3a3" }}
            iconType="circle"
          />
          <Bar dataKey="income" name="Income" fill={COLORS.income} radius={[1, 1, 0, 0]} maxBarSize={38} isAnimationActive={false} />
          <Bar dataKey="expense" name="Expenses" fill={COLORS.expense} radius={[1, 1, 0, 0]} maxBarSize={38} isAnimationActive={false} />
          <Line
            dataKey="net"
            name="Net profit"
            stroke={COLORS.net}
            strokeWidth={2}
            dot={{ r: 2.5, fill: "#000", stroke: "#fff", strokeWidth: 1.5 }}
            activeDot={{ r: 4 }}
            isAnimationActive={false}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}
